<template>
  <div v-if="data">
    <div class="design-container-inner">
      <LoadingWithSlot
        :is-loading="isLoading"
        height="300"
      >
        <div class="flex h-full w-full flex-col gap-4">
          <p class="text-base font-bold">
            {{ data.title }}
          </p>
          <BcChartBody
            class="-mt-10 !h-[300px] !max-h-[300px]"
            :high-chart-options="highChartOptions"
          />
          <p class="text-xs font-bold text-white/40">
            {{ data.source }}
          </p>
        </div>
      </LoadingWithSlot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BcChartBody } from 'xangle-charts'

import { useExplorerChart } from '~/composables/useExplorerChart'
import { useTranslator } from '~/composables/useTranslator'
import type { DefiChartModel } from '~/types/model/defi.model'

interface IProps {
  data: DefiChartModel
  isLoading: boolean
}

const props = defineProps<IProps>()
const { chartOptions, highChartOptions } = useExplorerChart({ useNavigator: true, showXYAxis: true })
const { translate } = useTranslator()

const chartData = toRef(props, 'data')

watch(() => chartData.value, () => {
  if (!chartData.value) return
  chartOptions.chartDataList = chartData.value.chartList.map(ele => {
    return {
      ...ele,
      name: translate(`analytics.${chartData.value.title}.${ele.name}`),
    }
  })
  chartOptions.yAxisOptions.right.unit = '$'
}, { deep: true, immediate: true })
</script>

<style scoped lang="scss">
.design-container-inner {
  @apply h-full p-4;
}

//.wide {
//  @apply w-full;
//
//  .design-container-inner {
//    padding: 0 !important;
//    border: none !important;
//  }
//}
</style>

<!-- period picker -->
<style lang="scss">
.vc-container {
  border: none !important;
  background-color: black !important;
}

.vc-pane {
  background-color: black !important;
}

.vc-focus.is-active,
.vc-highlights .vc-highlight-content-solid,
.date-range-container .vc-highlights .vc-day-layer ~ .vc-day-layer > .vc-highlight {
  &, &:hover {
    background-color: $primary-color !important;
  }
}

.date-range-container .vc-highlight-contnet-outline {
  @apply border-primary outline-primary #{!important};
}

.date-range-container .vc-day-layer .vc-day-layer:first-child > .vc-highlight {
  @apply bg-primary/40 border-primary #{!important};
}
</style>